import styled from 'styled-components';
import { border } from 'styled-system';

import { Box } from '@hivebrite/design-system/Box';

const EventCoverPicture = ({ coverPicture, ariaLabel = '', ...rest }) => (
  <Wrapper {...rest}>
    <StyledImage src={coverPicture} alt={ariaLabel} />
  </Wrapper>
);

export default EventCoverPicture;

const Wrapper = styled(Box).attrs(() => ({
  height: '100%',
  width: '100%',
  overflow: 'hidden',
}))`
  ${border}
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
`;
